import { z } from 'zod';
export const accountPasswordSchema = z
  .string()
  .min(12, 'Wachtwoord moet minimaal 12 tekens bevatten')
  .max(256)
  .regex(/[a-z]/, 'Wachtwoord moet een kleine letter bevatten')
  .regex(/[A-Z]/, 'Wachtwoord moet een hoofdletter bevatten')
  .regex(/[0-9]/, 'Wachtwoord moet een cijfer bevatten')
  .regex(/[^A-Za-z0-9]/, 'Wachtwoord moet een speciaal teken bevatten');

export const loginSchema = z.object({
  email: z.email('Ongeldig e-mailadres'),
  password: z.string().min(6, 'Wachtwoord moet minimaal 6 tekens bevatten'),
});

export const registerSchema = z.object({
  email: z.email('Ongeldig e-mailadres'),
  password: accountPasswordSchema,
  fullName: z.string().min(1, 'Naam is verplicht'),
});

export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;

export function defaultBackofficePath(roles: readonly string[]): '/projecten' | '/cases' | '/verboden' {
  if (roles.includes('admin') || roles.includes('registrations_operator')) return '/projecten';
  if (roles.includes('content_editor')) return '/cases';
  return '/verboden';
}
